export const CV_TECHNOLOGY_SOURCES = {
  GENERAL_SKILL: 'generalSkill',
  EMPLOYMENT: 'employmentHistory',
};
